/**
 * internal dependencies
 */
import { ICards } from '../../../models/cards.interface';
import { ICardGroupInsertUpdate } from '../../../models/cardgroup.interface';
import { getUniqueValues } from '../common/get-unique-values';
import { dropdown } from "../../dropdown";

/**
 * Formats a unique list of card groups for a dropdown.
 * 
 * @param {ICards[]} tableData the data
 * 
 * @returns void
 */
export const cardGroupDropDown = ( tableData: ICards[] | ICardGroupInsertUpdate[] ) => {
  if (!tableData) return;

  tableData = tableData.sort((a: ICards | ICardGroupInsertUpdate, b: ICards | ICardGroupInsertUpdate) => {
    if (a.cardGroupName < b.cardGroupName) {
      return -1;
    }
    if (a.cardGroupName > b.cardGroupName) {
      return 1;
    }
    return 0;
  });

  let cardGroupList: object[] = [];

  for(const [key, value] of Object.entries(tableData)) {
    cardGroupList.push({ id: value.cardGroupId, name: value.cardGroupName });
  }

  const finalCGList  = getUniqueValues(cardGroupList, 'id');

  dropdown(finalCGList, 'two', 'CardGroup', true, true, true);
}